var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fullpage-spinner"}},[(_vm.getSpinnerVisibilityStatus)?_c('div',{staticClass:"full-page-spinner__wrapper"},[_c('v-progress-circular',{attrs:{"size":120,"width":7,"color":"primary","indeterminate":""}})],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb08391","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AFullPageSpinner/index.vue
// module id = null
// module chunks = 